
import { defineComponent, PropType, ref } from "vue";

import { BaseButton } from "@tager/admin-ui";

import { FormValues } from "@/views/BasisProductForm/BasisProductForm.helpers";
import ParamBlock from "@/views/BasisProductForm/components/components/ParamBlock.vue";

type Props = Readonly<{
  values: FormValues;
}>;

export default defineComponent({
  name: "SettingBlock",
  components: { ParamBlock, BaseButton },
  props: {
    values: {
      type: Object as PropType<Props["values"]>,
      required: true,
    },
  },
  setup(props) {
    const params = ref(props.values.params);

    function addElement() {
      params.value.push({
        id: null,
        name: "",
        options: [],
        canDelete: true,
      });
    }

    return {
      addElement,
      params,
    };
  },
});
